// extracted by mini-css-extract-plugin
export default {"root":"IconList_root__g5TN4"};